import { DashboardVariable } from '@/dashboards/types';

export const createVariableMap = (dashboardVariables: DashboardVariable[]) =>
    dashboardVariables.reduce((acc, item) => {
        if (!acc[item.variableName]) {
            acc[item.variableName] = item;
        }
        return acc;
    }, {});

export const createVariableNameMap = (
    dashboardVariables: DashboardVariable[],
) =>
    dashboardVariables.reduce((acc, item) => {
        if (!acc[item.variableName]) {
            acc[item.variableName] = item.displayLabel ?? item.variableName;
        }
        return acc;
    }, {});
